jQuery(function ($) {
    if ($('.add-ons')) {
        $('.add-ons>.add-on:first-child').on('click', function () {
            $(this).siblings('*').slideToggle();
        })
        function resizePricingBlock(selector, unset = false) {

            var heightHolder = 0;
            $(selector).css('min-height', '0');
            if (unset == false) {
                $(selector).each(function () {
                    if ($(this).innerHeight() > heightHolder) {
                        heightHolder = $(this).innerHeight();
                    }
                });
                $(selector).css('min-height', heightHolder + 'px');
            }
        }

        resizePricingBlock('.pricing-block-container:not(.add-ons) .checklist__list');
        resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__header');
        resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__inner-content');

        window.addEventListener('resize', function () {
            if ($(window).width > 780) {
                resizePricingBlock('.pricing-block-container:not(.add-ons) .checklist__list');
                resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__header');
                resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__inner-content');
            } else {
                resizePricingBlock('.pricing-block-container:not(.add-ons) .checklist__list', true);
                resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__header', true);
                resizePricingBlock('.pricing-block-container:not(.add-ons) .pricing-block__inner-content', true);
            }
        });


    }





});